import React, { useContext } from 'react'
import ShopMenuItems from './MenuItems'
import { IShop } from '@dash.bar/types'
import { SessionContext } from '../../../../context/SessionContext'
import { isEmpty, isLoaded } from 'react-redux-firebase'
import LoadingScreen from '@webstollen/react-native/lib/components/LoadingScreen'
import { useTranslation } from '@webstollen/react-native/lib/hooks/useTranslation'
import NewUserTutorial from '../../../dashboard/components/NewCostumerTutorial/NewUserTutorial'
import PageWrapper from '../../../../components/PageWrapper'

const Shop = () => {
  const { t } = useTranslation()
  const { shops } = useContext(SessionContext)

  if (!isLoaded(shops)) {
    return <LoadingScreen text={t('loading.shop')} />
  }

  if (isEmpty(shops)) {
    return <NewUserTutorial />
  }

  const items = [
    ...Object.entries(shops)
      .filter(([, entry]) => entry != null)
      .map(([key, { icon }]) => ({
        domain: key,
        path: `/shops/${key}`,
        icon,
      })),
  ] as Array<IShop & { path: string }>

  return (
    <PageWrapper isScrollable={true}>
      <ShopMenuItems shops={items} />
    </PageWrapper>
  )
}
export default Shop
